<template>

    <div>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Profile</div>
            </base-header>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="text-overline">
                                    TIME
                                </div>
                                <v-list-item-title class="text-h5 blue--text ">
                                    30
                                </v-list-item-title>
                                <v-list-item-subtitle>DAYS</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar tile size="80">
                                <v-icon size="50" color="blue">payments</v-icon>
                            </v-list-item-avatar>
                        </v-list-item>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="text-overline">
                                    PROFIT
                                </div>
                                <v-list-item-title class="text-h5  green--text">
                                    10%
                                </v-list-item-title>
                                <v-list-item-subtitle>MOUNTH</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar tile size="80">
                                <v-icon size="50" color="green">where_to_vote</v-icon>
                            </v-list-item-avatar>
                        </v-list-item>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="text-overline">
                                    LOSS
                                </div>
                                <v-list-item-title class="text-h5  red--text">
                                    0.2%
                                </v-list-item-title>
                                <v-list-item-subtitle>MOUNTH</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar tile size="80">
                                <v-icon size="50" color="red">currency_exchange</v-icon>
                            </v-list-item-avatar>
                        </v-list-item>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="text-overline">
                                    BALANCE
                                </div>
                                <v-list-item-title class="text-h5 green--text">
                                    $455.894
                                </v-list-item-title>
                                <v-list-item-subtitle>MOUNTH</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar tile size="80">
                                <v-icon size="50" color="green">history_toggle_off
                                </v-icon>
                            </v-list-item-avatar>
                        </v-list-item>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>

             <v-col cols="12" lg="12" xl="12">
                <base-card>
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <v-card>
                            <v-toolbar flat dark>
                                <v-toolbar-title>User Profile</v-toolbar-title>
                            </v-toolbar>
                            <v-tabs  vertical>
                                <v-tab>
                                    <v-icon left>
                                        mdi-account
                                    </v-icon>
                                    Profile
                                </v-tab>
                                <v-tab>
                                    <v-icon left>
                                        mdi-lock
                                    </v-icon>
                                    Security
                                </v-tab>


                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <card-information></card-information>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <card-security></card-security>
                                    </v-card>
                                </v-tab-item>

                            </v-tabs>
                        </v-card>
                    </div>
                </base-card>
            </v-col>

        </v-row>
        <card-slide-group></card-slide-group>

    </div>
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";
    import CardInformation from '../../components/Cards/CardInformation'
    import CardSecurity from '../../components/Cards/CardSecurity'
    import CardSlideGroup from '../../components/Cards/CardSlideGroup'
    export default {
        components: {
            BaseCard,
BaseHeader,
            CardInformation,
            CardSecurity,
            CardSlideGroup


        },
    }
</script>